import { useContext, useEffect, useState } from 'react'
import { useFetch } from '@/hooks/useFetch'
import { Controller } from 'react-hook-form'
import { Input, Select } from 'alurkerja-ui'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'

interface IEmployeeNamesData {
  id: number
  name: string
  workEmail: string

  jobId: number
  jobName: string

  parentId: number
  parentName: string
  parentEmail: string
}

export default function LemburManagerName() {
  const { data: employeeNamesData, isLoading: employeeNamesIsLoading } = useFetch({
    path: '/api/v1/odoo/users',
  })

  const [employeeNames, setEmployeeNames] = useState<IEmployeeNamesData[]>([])
  const [selectedEmployee, setSelectedEmployee] = useState<IEmployeeNamesData | null>(null)

  const { setValue, control } = useContext<CustomComponentContextType>(CustomComponentContext)

  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium"

  useEffect(() => {
    if (employeeNamesData && Array.isArray(employeeNamesData)) {
      const formattedData = employeeNamesData.map(
        (item: any) =>
          ({
            id: item.id,
            name: item.name,
            jobId: item.jobId,
            jobName: item.jobName,
            workEmail: item.workEmail,
            parentId: item.parentId,
            parentName: item.parentName,
            parentEmail: item.parentEmail,
          } as IEmployeeNamesData),
      )

      setEmployeeNames(formattedData)
    }
  }, [employeeNamesData])

  const handleEmployeeNameChange = (value: any) => {
    // Set the selected employee name
    const selectedEmployee = employeeNames.find(item => item.id === value.value)

    if (selectedEmployee) {
      setSelectedEmployee(selectedEmployee)

      const username = selectedEmployee.parentEmail.split('@')[0]
      const employeeUsername = selectedEmployee.workEmail.split('@')[0]

      // Set the form values
      setValue('EMPLOYEE_NAME', selectedEmployee.name)
      setValue('EMPLOYEE_ID', selectedEmployee.id)
      setValue('manager', selectedEmployee.parentName)
      setValue('managerUsername', username)
      setValue('employeeUsername', employeeUsername)
      setValue('jobPosition', selectedEmployee.jobName)
    }
  }

  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="grid space-x-2">
          <div>
            <label htmlFor="manager" className={classNamesLabel}>
              Manager
            </label>
            <Controller
              name={'manager'}
              control={control}
              render={() => {
                return (
                  <>
                    <Input data-testid="manager" id="manager" defaultValue={selectedEmployee?.parentName} disabled />
                  </>
                )
              }}
            ></Controller>
          </div>
        </div>

        <div className="grid space-x-2">
          <div>
            <label htmlFor="EMPLOYEE_NAME" className={classNamesLabel}>
              Nama Karyawan
            </label>
            <Controller
              name={'EMPLOYEE_NAME'}
              control={control}
              render={({ fieldState }) => {
                return (
                  <>
                    <Select
                      data-testid="EMPLOYEE_NAME"
                      id="EMPLOYEE_NAME"
                      aria-label="Nama Karyawan" // Ensure this is included for direct matching
                      options={employeeNames.map(item => ({
                        value: item.id,
                        label: item.name,
                      }))}
                      isLoading={employeeNamesIsLoading}
                      onChange={value => handleEmployeeNameChange(value)}
                    />
                    {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                  </>
                )
              }}
            ></Controller>
          </div>
        </div>

        <div className="grid space-x-2">
          <div>
            <label htmlFor="jobPosition" className={classNamesLabel}>
              Job Position
            </label>
            <Controller
              name={'jobPosition'}
              control={control}
              render={() => {
                return (
                  <>
                    <Input
                      data-testid="jobPosition"
                      id="jobPosition"
                      defaultValue={selectedEmployee?.jobName}
                      disabled
                    />
                  </>
                )
              }}
            ></Controller>
          </div>
        </div>
      </div>
    </>
  )
}
